import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminBusinessesContent from "../admin/components/AdminBusinessesContent";

const SupportExecutiveBusinessWrapper = () => {
  return (
    <SupportLayout userRole="SE">
      <AdminBusinessesContent useOwnLayout={true} userRole="SE" />
    </SupportLayout>
  );
};

export default SupportExecutiveBusinessWrapper;
